const createComboData = (combo, comboItems) => {
  const totalAddedAmount =
    comboItems.reduce((t, selectedItem) =>
      t += selectedItem.addAmount * selectedItem.quantity
      , 0
    )

  const comboSetSalePrice =
    combo.comboSetSalePrice +
    totalAddedAmount

  const totalItemsSalePrice =
    comboItems.reduce((t, selectedItem) =>
      t +=
      (selectedItem.salePrice + selectedItem.addAmount) *
      selectedItem.quantity
      , 0
    )

  const comboDiscount =
    totalItemsSalePrice -
    comboSetSalePrice

  const comboData = {
    _id: combo._id,
    items: comboItems,
    name: combo.name,
    code: combo.code,
    comboSetSalePrice,
    totalItemsSalePrice,
    comboDiscount,
    isBuyxFreeX: combo.isBuyxFreeX
  }

  return comboData
}

export default createComboData